// Feature registry — defines every togglable dashboard module.
// `tab` controls where the module lives: 'heute' | 'board' | 'mehr'.
// `group` is purely for UI grouping in the picker.

export const FEATURES = [
  // ---- Core ----
  { id: 'daily_goals', label: 'Daily Goals',     tab: 'heute', group: 'core',     defaultOn: true,  description: '8 Checkboxes für deinen Tag — wake, training, cardio, …' },
  { id: 'heute_form',  label: 'Heute-Form',      tab: 'heute', group: 'core',     defaultOn: false, description: '16-Feld-Formular: wake, BP, weight, energy, diary, …' },
  { id: 'srank',       label: 'S-Rank Tag',      tab: 'heute', group: 'core',     defaultOn: true,  description: '7 Kriterien → E bis S Rank. Definiere deinen S-Rank-Tag.' },
  { id: 'streak',      label: 'Streak Heatmap',  tab: 'heute', group: 'core',     defaultOn: true,  description: '30/90/180-Tage Heatmap, current + best Streak.' },

  // ---- Productivity ----
  { id: 'quests',      label: 'Quests',          tab: 'board', group: 'todo',     defaultOn: true,  description: 'Macro / Micro / Problem Quests.' },
  { id: 'kanban',      label: 'Kanban',          tab: 'board', group: 'todo',     defaultOn: true,  description: 'Listen + Karten + Archive + Undo.' },

  // ---- Body ----
  { id: 'macrobot',    label: 'Macrobot',        tab: 'heute', group: 'body',     defaultOn: false, description: 'Food-Log mit Chat-Bar + Food-DB.' },
  { id: 'caffeine',    label: 'Koffein Tracker', tab: 'heute', group: 'body',     defaultOn: false, description: '6 Presets, mg-Total pro Tag.' },
  { id: 'supplements', label: 'Supplements',     tab: 'heute', group: 'body',     defaultOn: false, description: 'Morning/Evening Plan + Daily-Check.' },
  { id: 'body',        label: 'Body Measure',    tab: 'mehr',  group: 'body',     defaultOn: false, description: 'Weight, Chest, Waist, Hips, …' },
  { id: 'gym',         label: 'Gym Log',         tab: 'mehr',  group: 'body',     defaultOn: false, description: 'Push/Pull/Legs Sätze + Gewichte.' },

  // ---- Mind ----
  { id: 'reflection',  label: 'Book Reflection', tab: 'heute', group: 'mind',     defaultOn: false, description: 'Aktuelles Buch + heutige Sessions.' },
  { id: 'learning',    label: 'Learning Log',    tab: 'mehr',  group: 'mind',     defaultOn: false, description: 'Topics + Minuten + Notes.' },

  // ---- Lifestyle ----
  { id: 'wishlist',    label: 'Wishlist',        tab: 'mehr',  group: 'lifestyle',defaultOn: false, description: 'Wünsche mit URL + Priority.' },
  { id: 'finance',     label: 'Finance',         tab: 'mehr',  group: 'lifestyle',defaultOn: false, description: 'Einnahmen / Ausgaben pro Kategorie.' },

  // ---- AI ----
  { id: 'coach',       label: 'Coach (Claude)',  tab: 'fab',   group: 'ai',       defaultOn: true,  description: 'FAB unten rechts. Claude API + DeepSeek Vision.' },

  // ---- Admin ----
  { id: 'db_viewer',   label: 'Database Viewer', tab: 'header',group: 'admin',    defaultOn: false, description: 'Read-only Tabellen-Ansicht deiner Daten.' },
]

export const FEATURE_GROUPS = {
  core:      'Kern',
  todo:      'Productivity',
  body:      'Body',
  mind:      'Mind',
  lifestyle: 'Lifestyle',
  ai:        'AI',
  admin:     'Admin',
}

export const FEATURE_BY_ID = Object.fromEntries(FEATURES.map((f) => [f.id, f]))

export const DEFAULT_ENABLED = FEATURES.filter((f) => f.defaultOn).map((f) => f.id)

export function isEnabled(profile, id) {
  const list = profile?.enabled_features
  if (!Array.isArray(list)) return DEFAULT_ENABLED.includes(id)
  return list.includes(id)
}
